import { render, staticRenderFns } from "./GestorDocumental.vue?vue&type=template&id=706ba1c6&scoped=true"
import script from "./GestorDocumental.vue?vue&type=script&lang=js"
export * from "./GestorDocumental.vue?vue&type=script&lang=js"
import style0 from "./GestorDocumental.vue?vue&type=style&index=0&id=706ba1c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ba1c6",
  null
  
)

export default component.exports